import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=156a72a4&scoped=true&"
import script from "./Bar.vue?vue&type=script&lang=js&"
export * from "./Bar.vue?vue&type=script&lang=js&"
import style0 from "./Bar.vue?vue&type=style&index=0&id=156a72a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a72a4",
  null
  
)

export default component.exports